import { type ReactNode, useState, useMemo } from 'react'
import { DropdownContent } from 'shared/ui/Dropdown/ui/DropdownContent'
import { Dropdown, DropdownGroup, DropdownTextInput, type IDropdownItem } from 'shared/ui/Dropdown'
import { Scrollbar } from 'shared/ui/Scrollbar'
import { prepareSearchRegex } from 'shared/lib/prepareSearch'
import { type IChatbotActionType } from 'entities/Chatbot/model/type'

import styles from './styles.module.scss'

type IActionsDropdownProps = {
  handleAddAction: (action: IChatbotActionType) => void
  items: IDropdownItem[]
  triggerComponent: () => ReactNode
  dropdownWidth?: number
  handleToggleDropdown?: () => void
  className?: string
  groupTitle?: string
}

export const ActionsDropdown = ({
  dropdownWidth,
  handleToggleDropdown,
  handleAddAction,
  items,
  className,
  groupTitle,
  triggerComponent,
}: IActionsDropdownProps) => {
  const [searchTerm, setSearchTerm] = useState('')

  const termActions = useMemo(() => {
    const term = searchTerm.trim()

    if (!term) return items

    const searchRegex = prepareSearchRegex(term)

    return items.filter((action) => searchRegex.test(action.label))
  }, [searchTerm])

  const handleToggle = (open: boolean) => {
    if (open) setSearchTerm('')
    handleToggleDropdown?.()
  }

  return (
    <Dropdown
      className={className}
      ariaLabel='AIAgentAddAction'
      width={dropdownWidth}
      onToggle={handleToggle}
      triggerComponent={triggerComponent}
      placement='bottom'
      customComponent={(close) => (
        <DropdownContent noPadding>
          <DropdownTextInput
            textFieldProps={{
              value: searchTerm,
              onChange: setSearchTerm,
              InputProps: {
                placeholder: 'Search',
              },
            }}
          />
          <Scrollbar autoHeight autoHeightMin={0} autoHeightMax={300}>
            {!!termActions.length ? (
              <DropdownGroup
                title={groupTitle}
                items={termActions}
                isScroll={false}
                onChange={({ id }) => {
                  close()
                  handleAddAction(id as IChatbotActionType)
                }}
                stylesWrap={{ borderBottom: 'none' }}
              />
            ) : (
              <div className={styles.noResults}>No results found</div>
            )}
          </Scrollbar>
        </DropdownContent>
      )}
    />
  )
}
